module.exports = __webpack_public_path__ + "img/mingsheng.a16b0572.png";